import {
  ITennisLiveScore
} from "@sky-it-livedata/livedata-sports-design-system";
import { ErrorName, WidgetError } from "../../../utils/errors";
import { LiveScoreData } from "../types";
import { intcmpMap } from "../../../utils/intcmp";
import { CreateLiveScoreWidgetInputSchema } from "cdk/graphql";
import { isValidLiveScore } from "./typeguards";


export const transformQuery = (obj: LiveScoreData): ITennisLiveScore => {
  console.log(obj);
  if (isValidLiveScore(obj)) {
      CreateLiveScoreWidgetInputSchema().parse(obj.data.getLiveScoreWidget, {reportInput: true});
      const { liveTournaments, ctaUrls } = obj?.data?.getLiveScoreWidget;

      return {
        liveTournaments,
        ctaUrls: {
          atpCalendarUrl: { url: ctaUrls?.atpCalendarUrl || "", intcmp: intcmpMap.liveScoreAtpCalendar},
          atpRankingUrl: { url: ctaUrls?.atpRankingUrl || "", intcmp: intcmpMap.liveScoreAtpRanking},
          wtaCalendarUrl: { url: ctaUrls?.wtaCalendarUrl || "", intcmp: intcmpMap.liveScoreWtaCalendar},
          wtaRankingUrl: { url: ctaUrls?.wtaRankingUrl || "", intcmp: intcmpMap.liveScoreWtaRanking},
        },
        resultsIntcmp: intcmpMap.liveScoreAtpResults,
      } as ITennisLiveScore;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LiveScoreQuery object',
      data: obj
    });
  }
};